export default "__VITE_ASSET__B3n8Zua0__"